import { render, staticRenderFns } from "./InvoicesListItem.vue?vue&type=template&id=ee4ed3aa&"
import script from "./InvoicesListItem.vue?vue&type=script&lang=js&"
export * from "./InvoicesListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports